import PostTrade from "./../Images/CommonImages/PostTrade.svg";
import Warehouses from "./../Images/CommonImages/Warehouses.svg";
import ReleaseOrder from "./../Images/CommonImages/release-order.svg";
import ReleaseStock from "./../Images/CommonImages/ReleaseStock.svg";
import StorageInvoices from "./../Images/CommonImages/storageInvoice.svg";
import DollarIcon from "./../Images/CommonImages/DollarIcon.svg";
import releaseStockIcon from "./../Images/CommonImages/releaseStockIcon.svg";
import faqIcon from "./../Images/CommonImages/faqIcon.svg";
import tradeContractIcon from "./../Images/CommonImages/tradeContractIcon.svg";
import postRequirementIcon from "./../Images/CommonImages/postRequirementIcon.svg";
import DisbursementIcon from "./../Images/CommonImages/DisbursementIcon.svg";
import StorageInvoiceIcon from "./../Images/CommonImages/StorageInvoiceIcon.svg";
import paymentLedgerIcon from "./../Images/CommonImages/paymentLedgerIcon.svg";

import Home from "./../Images/CommonImages/Home.svg";
import {
  FindContracts,
  accountStatementIcon,
  stockIcon,
} from "./../icon_assets";

const parsedUserData = JSON.parse(
  localStorage.getItem("userDashBoardData") || "{}"
);

const isEitherCIBILActive =
  parsedUserData.isActiveTuIndividual || parsedUserData.isActiveTuCommercial;

export const optionsData = [
  {
    icon: Home,
    text: "Book Warehouse",
    link: "/my-storage/warehouses",
  },
  {
    icon: releaseStockIcon,
    link: "/my-storage/commodities",
    text: "Release Stock",
  },

  {
    icon: DollarIcon,
    text: "WRF A/C Statement",
    link: "/finance?download=true",
  },
  {
    icon: DisbursementIcon,
    text: "Disbursement",
    link: "/finance",
  },
  {
    icon: postRequirementIcon,
    text: "Post Requirement",
    link: "/post-your-requirements",
  },
  {
    icon: tradeContractIcon,
    text: "Trade Contracts",
    link: "/trade/contracts-list",
  },
  {
    icon: paymentLedgerIcon,
    text: "Payment Ledger",
    link: "/finance?paymentLedger=true",
  },
  isEitherCIBILActive && {
    icon: StorageInvoices,
    text: "Check CIBIL Score",
    link: "/credit-score",
  },
  !isEitherCIBILActive && {
    icon: Warehouses,
    text: "Find Warehouses",
    link: "/warehouse/find-a-warehouse",
  },
].filter(Boolean);
